/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-panel[_ngcontent-%COMP%]{display:flex;justify-items:start;padding:0 0 10px 10px;background-color:#f5f5f5}.filter-panel[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-right:10px}dx-data-grid[_ngcontent-%COMP%]{flex:auto;height:calc(100% - 110px);margin:0 12px}.red[_ngcontent-%COMP%]{background-color:#f89a9a}.green[_ngcontent-%COMP%]{background-color:#a8f8a8}.orange[_ngcontent-%COMP%]{background-color:#f8d6a8}"];
export { styles as styles };
